/* istanbul ignore file */
import { PaymentStatus } from "#graphql/supergraphTypes";
import { MoneyType } from "../Money";
import { FailedPaymentDetails } from "../PayableWorkflow/components/PaymentFailedBanner/types";

export type PositionRowItem = {
  id: string;
  paymentId: string | undefined;
  payee: string | undefined;
  paymentInstructions: string | null | undefined;
  method: string | null | undefined;
  amount: MoneyType | undefined;
  hostName: string | undefined;
  positionId: string | undefined;
  accountId: string | undefined;
  status: PaymentStatus;
  referenceNumber: string | null | undefined;
  failedPaymentDetails?: FailedPaymentDetails;
};

export enum PositionStatusIcons {
  PROCESSING = "sync-alt",
  SETTLED = "check",
  FAILED = "exclamation-circle",
  PENDING = "hourglass-start",
  CANCELED = "times-circle",
}
export enum PositionStatusText {
  PROCESSING = "Processing",
  SETTLED = "Settled",
  FAILED = "Failed",
  PENDING = "Pending",
  CANCELED = "Canceled",
}
